export enum PickerInputMode {
  Single = 'single',
  Range = 'range',
  Multiply = 'multiple'
}

export enum PickerFormat {
  Time = 'time',
  Date = 'date',
  DateTime = 'dateTime'
}

export interface PickerDayFn {
  (date: Date): boolean
}

export type DateRange = {
  from: string
  to: string
}
